export default "__VITE_ASSET__7cuSH4pH__"